import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useMantineTheme} from "@mantine/core";
import './dashboardOverView.css'
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import React from "react";

export type KpiStatProps = {
    title: string | number,
    description: string
    color: string
    icon: IconProp,
    onClick?: () => void
}

export function DashboardStatCard(props: KpiStatProps) {
    const theme = useMantineTheme();

    const hasPointer = !!props.onClick

    const onClickCard = (e: React.MouseEvent<HTMLDivElement>, title: string | number) => {
        e.preventDefault()
        if (props.onClick) {
            props.onClick()
        }
    }
    return (
        <div className={"kpi-stat-card " + (hasPointer && "pointer")} onClick={(e) => onClickCard(e, props.title)}
             style={
                 {
                     // backgroundColor: theme.colorScheme === 'light' ? "white" : theme.colors[props.color][9]
                 }
             }>
            <div className={"kpi-stat-content"} style={{color: "black"}}>
                <span className="kpi-stat-title">{props.title}</span>
                <div className={"centered scale-up kpi-stat-icon"}
                     style={{backgroundColor: theme.colors[props.color][5]}}>
                    <FontAwesomeIcon color={"white"} size={"2x"} icon={props.icon}/>
                </div>
            </div>
            <div style={{textAlign: "left"}}>
                <span className="kpi-stat-desc">{props.description}</span>
            </div>

        </div>
    )
}
